"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Parsing Request Location Header
 * This version only support parsing cloudflare headers
 * @param {Request} req - String
 * @returns parsed header cotain: request Ip, request Country, request agent
 */
function parseLocationHeader(req) {
    const ip = req.get('cf-connecting-ip') || '';
    const country = req.get('cf-ipcountry') || '';
    const agent = req.get('user-agent') || '';
    return {
        ip,
        country,
        agent,
    };
}
/**
 * Parsing Blockpass Custom Header
 * @param {Request} req - String
 * @returns parsed header containing: accType, bpService, clientOS, clientVersion
 */
function parseBlockpassHeader(req) {
    const accType = req.get('x-blockpass-acctype') || 'unknow';
    const bpService = req.get('x-blockpass-service') || 'unknow';
    const clientOS = req.get('x-client-os') || 'unknow';
    const clientVersion = req.get('x-client-version') || 'unknow';
    return {
        accType,
        bpService,
        clientOS,
        clientVersion,
    };
}
exports.default = { parseLocationHeader, parseBlockpassHeader };
